import React from 'react';
import { Drawer } from 'antd';
import MyCreateContactForm, {
  ICreateContactFormValues,
} from './CreateContactForm';

interface ICreateContactProps {
  visible: boolean;
  onSubmit: (values: ICreateContactFormValues) => any;
  onClose: Function;
}

const defaultProps: ICreateContactProps = {
  visible: false,
  onSubmit: () => {},
  onClose: () => {},
};

const CreateContact: React.FC<ICreateContactProps> = (
  props: ICreateContactProps = defaultProps,
) => {
  return (
    <CreateContactView
      visible={props.visible}
      onSubmit={props.onSubmit}
      onClose={props.onClose}
    />
  );
};

interface ICreateContactViewProps {
  visible: boolean;
  onSubmit: (values: ICreateContactFormValues) => any;
  onClose: Function;
}

const CreateContactView: React.FC<ICreateContactViewProps> = (
  props: ICreateContactViewProps,
) => {
  return (
    <Drawer
      title={'Crear nuevo contacto'}
      width={350}
      visible={props.visible}
      forceRender={true}
      destroyOnClose={true}
      onClose={() => props.onClose()}
    >
      <MyCreateContactForm onSubmit={props.onSubmit} />
    </Drawer>
  );
};

export default CreateContact;
